import React, { memo, useEffect, useState } from 'react';
import PropTypes, { bool } from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';

import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';
import reducer from './reducer';
import saga from './saga';

import { flushState } from './actions';
import { makeSelectTestContainer } from './selectors';

// styles
import './style.scss';
// assets
import CustomIcons from 'components/CustomIcons';


export function TestContainer({ flushState }) {
  useInjectReducer({ key: 'testContainer', reducer });
  useInjectSaga({ key: 'testContainer', saga });

  //const [example, setExample] = useState('Hello world');

  /**
   * Loading data for rendering in a component
   * - work like ComponentDidUpdate
   */
  useEffect(() => {}, []);

  // Clearing the state after unmounting a component
  useEffect(() => {
    return () => {
      // Anything in here is fired on component unmount.
      flushState();
    };
  }, []);

  // render function
  return (
    <div>
      <CustomIcons type="teacher" />
      <CustomIcons type="parent" />
      <CustomIcons type="school" />
      <CustomIcons type="school-simple" />
      <CustomIcons type="present-finish" />
      <CustomIcons type="check-present" />
      <CustomIcons type="check-absent" />
      <CustomIcons type="no-proof" />
      <CustomIcons type="proof-document" />
      <CustomIcons type="proof-photo" />
      <CustomIcons type="delete" />
      <CustomIcons type="garbage" />
      <CustomIcons type="star-empty" />
      <CustomIcons type="star" />
      <CustomIcons type="virus" />
      <CustomIcons type="sick-leave" />
      <CustomIcons type="no-absence" />
      <CustomIcons type="sickness" />
      <CustomIcons type="quill" />
      <CustomIcons type="medical" />
      <CustomIcons type="absence-checked-active" />
      <CustomIcons type="absence-checked" />
      <CustomIcons type="absence-active" />
      <CustomIcons type="quil" />
      <CustomIcons type="absence" />
      <CustomIcons type="filter-full" />
      <CustomIcons type="filter" />
      <CustomIcons type="sort" />
      <CustomIcons type="book-active" />
      <CustomIcons type="book" />
      <CustomIcons type="users" />
      <CustomIcons type="academic-active" />
      <CustomIcons type="academic" />
      <CustomIcons type="logout" />
      <CustomIcons type="close" />
      <CustomIcons type="pause" />
      <CustomIcons type="trophy" />
      <CustomIcons type="time" />
      <CustomIcons type="search" />
      <CustomIcons type="registred" />
      <CustomIcons type="replay" />
      <CustomIcons type="person" />
      <CustomIcons type="document-active" />
      <CustomIcons type="document" />
      <CustomIcons type="notifications-in-app" />
      <CustomIcons type="microphone-active" />
      <CustomIcons type="microphone" />
      <CustomIcons type="share2" />
      <CustomIcons type="share" />
      <CustomIcons type="bookmarked" />
      <CustomIcons type="bookmark-white" />
      <CustomIcons type="bookmark" />
      <CustomIcons type="dots-vertical" />
      <CustomIcons type="photo" />
      <CustomIcons type="calendar-active" />
      <CustomIcons type="calendar" />
      <CustomIcons type="arrow-left" />
      <CustomIcons type="arrow-right" />
      <CustomIcons type="verified-white2" />
      <CustomIcons type="verified-white" />
      <CustomIcons type="verified" />
      <CustomIcons type="edit" />
      <CustomIcons type="home-active" />
      <CustomIcons type="home" />
      <CustomIcons type="view" />
      <CustomIcons type="vote" />
      <CustomIcons type="feed-active" />
      <CustomIcons type="feed" />
      <CustomIcons type="comments" />
      <CustomIcons type="parameters" />
      <CustomIcons type="casestudy-active" />
      <CustomIcons type="casestudy" />
      <CustomIcons type="downvote" />
      <CustomIcons type="upvote" />
      <CustomIcons type="user" />
      <CustomIcons type="save" />
      <CustomIcons type="group" />
      <CustomIcons type="group-active" />
    </div>
  );
}

TestContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  flushState: PropTypes.func.isRequired,
};

const mapStateToProps = createStructuredSelector({
  testContainer: makeSelectTestContainer(),
});

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    flushState: () => dispatch(flushState()),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, memo)(TestContainer);
